import Service from "../Service";

const resource = "hmnbusturn/";

export default {
    // Guardar turno de bus
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID:requestID },
        });
    },

    // Guardar entrada de persona al bus
    saveentrypersonbus(obj, requestID) {
        return Service.post(resource + "saveentrypersonbus", obj, {
            params: { requestID:requestID },
        });
    },

    // Activar turno de bus
    busturnactive(obj, requestID) {
        return Service.post(resource + "busturnactive", obj, {
            params: { requestID:requestID },
        });
    },

    quantitypersonbyturnactive(obj, requestID) {
        return Service.post(resource + "quantitypersonbyturnactive", obj, {
            params: { requestID:requestID },
        });
    },

    // Registrar asistencia
    registerAttendance(data) {
        return Service.post("bus-attendance", data);
    },

    // Obtener asistencia
    getAttendance(params) {
        return Service.get("bus-attendance", { params });
    },

    // Asignar usuario a ruta
    assignUserRoute(data) {
        return Service.post("user-route-assignment", data);
    },

    // Obtener asignaciones de usuario
    getUserAssignments(params) {
        return Service.get("user-route-assignment", { params });
    }
};